import { useCallback } from 'react';
import Raven from 'raven-js';
import { useRecommendationsState } from './recommendationsStore';
import { usePostRankedRecommendationsContentEngagedFeedback } from 'academy-common-lib/features/recommendations/hooks/usePostRankedRecommendationsContentEngagedFeedback';
import { getDemographics } from 'demographics-client';
import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
export const GET_DEMOGRAPHICS_QUERY = registerQuery({
  fieldName: 'demographics',
  args: [],
  fetcher: getDemographics
});
export const useRecommendationsTopicPreference = () => {
  var _data$user;
  const {
    data,
    loading,
    error
  } = useQuery(GET_DEMOGRAPHICS_QUERY);
  return {
    recommendationsTopicPreference: data === null || data === void 0 || (_data$user = data.user) === null || _data$user === void 0 ? void 0 : _data$user.hubInterest,
    recommendationsTopicPreferenceLoading: loading,
    recommendationsTopicPreferenceError: error
  };
};
export const usePostRecommendationsContentEngagedFeedback = () => {
  const {
    clearLastClickedRecommendationItem,
    lastClickedRecommendationItem
  } = useRecommendationsState();
  const {
    postRankedRecommendationsContentEngagedFeedback,
    postRankedRecommendationsContentEngagedFeedbackError,
    postRankedRecommendationsContentEngagedFeedbackLoading
  } = usePostRankedRecommendationsContentEngagedFeedback();
  const postRecommendationsContentEngagedFeedback = useCallback(({
    item,
    contentId
  }) => {
    // do not send feedback if there is no last clicked recommendation item or if it doesn't match the current item
    if (!lastClickedRecommendationItem || lastClickedRecommendationItem.item.id !== item.id || lastClickedRecommendationItem.item.type !== item.type) return;
    return postRankedRecommendationsContentEngagedFeedback({
      correlationId: lastClickedRecommendationItem.correlationId,
      contentContainerType: item.type,
      resultId: item.id,
      engagedContentId: contentId
    }).catch(Raven.captureException.bind(Raven)).finally(() => {
      clearLastClickedRecommendationItem();
    });
  }, [clearLastClickedRecommendationItem, lastClickedRecommendationItem, postRankedRecommendationsContentEngagedFeedback]);
  return {
    postRecommendationsContentEngagedFeedback,
    postRecommendationsContentEngagedFeedbackError: postRankedRecommendationsContentEngagedFeedbackError,
    postRecommendationsContentEngagedFeedbackLoading: postRankedRecommendationsContentEngagedFeedbackLoading
  };
};